export { default } from './VerificationPayment';
